var ROOM_TYPE;
(function (ROOM_TYPE) {
    ROOM_TYPE["BedroomSingle"] = "BedroomSingle";
    ROOM_TYPE["BedroomDouble"] = "BedroomDouble";
    ROOM_TYPE["Bathroom"] = "Bathroom";
    ROOM_TYPE["WC"] = "WC";
    ROOM_TYPE["Utility"] = "Utility";
    ROOM_TYPE["Kitchen"] = "Kitchen";
    ROOM_TYPE["Dining"] = "Dining";
    ROOM_TYPE["Living"] = "Living";
    ROOM_TYPE["KitchenDining"] = "KitchenDining";
    ROOM_TYPE["KitchenLiving"] = "KitchenLiving";
    ROOM_TYPE["KitchenLivingDining"] = "KitchenLivingDining";
    ROOM_TYPE["DiningLiving"] = "DiningLiving";
    ROOM_TYPE["Storage"] = "Storage";
    ROOM_TYPE["Hallway"] = "Hallway";
    ROOM_TYPE["Terrace"] = "Terrace";
    ROOM_TYPE["Generic"] = "Generic";
})(ROOM_TYPE || (ROOM_TYPE = {}));

export { ROOM_TYPE };
//# sourceMappingURL=room-type.js.map
